export default {
	到: 'to',
	登录: 'Login',
	第三方登录: 'Third-party login',
	点击登录: 'click to log in',
	点击注册: 'click to register',
	记住我: 'Remember me',
	距离完成注册仅剩下最后一步: 'You are one step away from completing registration!',
	没有账号: 'No account yet',
	设置密码: 'Set password',
	完成注册: 'Complete registration',
	'忘记密码?': 'Forgot password?',
	修改密码: 'Change password',
	验证码: 'Verification code',
	已有账号: 'Already have an account',
	重新发送: 'Resend',
	注册: 'Register',
	注册验证码: 'Registration verification code',
	重置密码: 'Reset password',
	重置密码成功: 'Password reset successful',
	重置密码成功提示: 'Please keep your new password safe and log in with it.',
}
